import Cache from './lib/cache'

export default class Auth {
  // single instance
  static getInstance(options) {
    if (!Auth.instance) {
      Auth.instance = new Auth(options)
      return Auth.instance
    }
    return Auth.instance
  }

  constructor(config) {
    this.config = config
  }

  /**
   * 登录
   *
   * @param {*} loginName        用户名
   * @param {*} password        密码
   */
  login(params) {
    return new Promise((resolve, reject) => {
      peace.http
        // .post(this.config.baseApi + '/portal/login', params)
        .post('/open-mall-portal/portal/login', params)
        .then((res) => {
          if (res.data.success) {
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  /**
   * 判断登录状态
   */
  isLogin() {
    return Cache.getAuth() ? true : false
  }

  /**
   * 登出
   */
  logout() {
    return new Promise((resolve, reject) => {
      peace.http
        // .get(this.config.baseApi + '/portal/logout')
        .get('/open-mall-portal/portal/logout')
        .then((res) => {
          this.removeAll()
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  /**
   * 获取鉴权信息
   */
  getAuth() {
    return new Promise((resolve) => {
      resolve(Cache.getAuth())
    })
  }

  /**
   * 清空鉴权信息
   */
  removeAuth() {
    Cache.removeAuth()
    return true
  }

  /**
   * 获取用户信息
   * @param {*} isLogin 是否是登陆（登陆时不取缓存，防止一个浏览器同时登陆多个账户，缓存被重复使用）
   */
  getAccountInfo(isLogin = false) {
    return new Promise((resolve, reject) => {
      let accountInfo = Cache.getAccountInfo()
      if (accountInfo && !isLogin) {
        resolve(accountInfo)
      } else {
        peace.http
          // .get(this.config.baseApi + '/portal/current_user')
          .get('/open-mall-portal/portal/current_user')
          .then((res) => {
            Cache.setAccountInfo(res.data.userInfo)
            Cache.setCurrentUserInfo(res.data)
            resolve(res.data.userInfo)
          })
          .catch((err) => {
            reject(err)
          })
      }
    })
  }
  /**
   * 获取用户认证状态
   */
  getState() {
    let currentUserInfo = Cache.getCurrentUserInfo()
    //state  0:待认证，1:已认证，2:已驳回
    return currentUserInfo && currentUserInfo.enterpriseInfo && currentUserInfo.enterpriseInfo.state
  }

  /**
   * 获取用户全部信息
   */
  getCurrentUserInfo() {
    return Cache.getCurrentUserInfo()
  }
  /**
   * 设置用户全部信息
   */
  setCurrentUserInfo(accountInfo) {
    Cache.setCurrentUserInfo(accountInfo)
    return accountInfo
  }

  /**
   * 设置用户信息
   */
  setAccountInfo(accountInfo) {
    Cache.setAccountInfo(accountInfo)
    return accountInfo
  }

  /**
   * 清空用户信息
   */
  removeAccountInfo() {
    Cache.removeAccountInfo()
    Cache.removeCurrentUserInfo()
    return true
  }

  /**
   * 获取用户菜单
   *
   */
  getAccountMenu() {
    return new Promise((resolve, reject) => {
      let accountMenu = Cache.getAccountMenu()
      const state = this.getState()
      if (state !== 1) {
        return resolve(null)
      }
      if (accountMenu) {
        resolve(accountMenu)
      } else {
        peace.http
          // .get(this.config.baseApi + '/portal/menus')
          .get('/open-mall-portal/portal/menus')
          .then((res) => {
            const adpaterMenuList = []

            res.data.forEach((menu) => {
              const menuStruct = {}
              menuStruct.menuIcon = menu.menuIcon
              menuStruct.menuName = menu.menuName
              menuStruct.id = menu.id
              menuStruct.parentId = menu.parentId
              menuStruct.sort = menu.sort

              menuStruct.closable = menu.closable
              menuStruct.enable = menu.enable
              menuStruct.menuAlias = menu.menuAlias
              menuStruct.menuPath = menu.menuPath
              menuStruct.menuRoute = menu.menuRoute

              menuStruct.virtual = menu.virtual
              adpaterMenuList.push(menuStruct)
            })

            //sort排序
            adpaterMenuList.sort((a, b) => {
              return a.sort - b.sort
            })

            Cache.setAccountMenu(adpaterMenuList)
            resolve(adpaterMenuList)
          })
          .catch((err) => {
            reject(err)
          })
      }
    })
  }

  /**
   * 设置用户菜单
   */
  setAccountMenu(accountMenu) {
    Cache.setAccountMenu(accountMenu)
    return accountMenu
  }

  /**
   * 清空用户菜单
   */
  removeAccountMenu() {
    Cache.removeAccountMenu()
    return true
  }

  /**
   * 清空auth相关所有信息
   */
  removeAll() {
    Cache.removeAllAccountInfo()
    return true
  }

  /**
   * 工作流
   *
   */
  workFlowAuth(params) {
    return new Promise((resolve, reject) => {
      this.login(params)
        .then(() => {
          return this.getAccountInfo(true)
        })
        .then(() => {
          return this.getAccountMenu()
        })
        .then(() => {
          let auth = this.getAuth()
          let accountInfo = this.getAccountInfo()
          let accountMenu = this.getAccountMenu()
          let currentUserInfo = this.getCurrentUserInfo()
          let result = { auth, accountInfo, accountMenu, currentUserInfo }
          resolve(result)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
